import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { HowItWorks } from './components/HowItWorks';
import { FAQAndPricing } from './components/FAQAndPricing';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-terracotta selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      <Mechanism data-id="element-4" />
      <Deliverables data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <FAQAndPricing data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}